module.exports = __webpack_public_path__ + "51811d48501dfd458c2ff5db2c0eb4b5.pdf";